<template>

    <div class="modal attendance-modal fade" id="setUserEmployeesBoxModal" tabindex="-1" aria-labelledby="setUserEmployeesBoxModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Collega's toevoegen/verwijderen</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body pt-3 pb-4 px-4">

                    <div class="employees-list" v-if="this.employeesGrouped !== null">
                        <div v-for="employeesGroupedItem in employeesGrouped">
                            <h4 class="profile ms-4 mb-1">{{ employeesGroupedItem.profileName }}</h4>
                            <label class="employee mb-3" v-for="item in employeesGroupedItem.employees" :for="item.id" role="button">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input
                                            v-model="item.is_linked"
                                            type="checkbox"
                                            v-bind:id="item.id">
                                        <div>
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                </div>
                <div class="modal-body pt-3 pb-4 px-4 d-flex">
                    <button
                        class="btn btn-primary ms-auto px-3 py-2 text-sm"
                        @click="linkEmployees()"
                    >
                        Verstuur <i class="fa fa-save" :class="{ 'fa fa-circle-o-notch fa-spin' : this.btnActionLoader }"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";
import {ref} from "vue";

export default {
    name: 'link-user-employees-modal',
    data() {
        return {
            employeesGrouped: [{
                'profileName': '',
                'employees': [{
                    key: {
                        id: '',
                        name: '',
                        city: '',
                        avatar: '',
                        is_linked: '',
                        is_present: '',
                    },
                }],
            }],
            btnActionLoader: false,
        }
    },
    methods: {
         getEmployees() {
            axios.get('api/get-employees')
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.employeesGrouped = response.data.employeesGrouped;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        linkEmployees() {

            this.btnActionLoader = true;

            axios.post('api/link-employee', {
                employees: this.employeesGrouped,
            })
                .then(response => {
                    if (response.data.status === 422) {
                        this.conversationModal.hide();
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('refetchEmployees');
                    this.btnActionLoader = false;

                    setTimeout(() => this.modal.hide(), 500);
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                });
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('setUserEmployeesBoxModal'));

        EventBus.$on('linkUserEmployees', () => {
            this.getEmployees();
            this.modal.show();
        });
    },
}
</script>
